export const ATENDIMENTO = 'ATENDIMENTO';
export const ATENDIMENTO_START = 'ATENDIMENTO_START';
export const ATENDIMENTO_SUCCESS = 'ATENDIMENTO_SUCCESS';
export const ATENDIMENTO_ERROR = 'ATENDIMENTO_ERROR';

export const CONTATOS = 'CONTATOS';
export const CONTATOS_START = 'CONTATOS_START';
export const CONTATOS_SUCCESS = 'CONTATOS_SUCCESS';
export const CONTATOS_ERROR = 'CONTATOS_ERROR';
